var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('full-page',{ref:"fullpage",attrs:{"options":_vm.options,"id":"fullpage"}},[_c('Home',{attrs:{"move-to":_vm.api}}),_c('About'),_c('Features'),_c('Contact')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }